<!-- iPhone-like camera UI with record button at the bottom center -->
<div class="action-loader-modal">
  <div class="camera-modal-container">
    <ng-container *ngIf="isPreview">
      <div
        class="voe-preview-content"
        innerHTML="{{ 'videoOpenEnded.surveyVoePreviewPopover' | translate }}"
      ></div>
    </ng-container>
    <div class="absolute top-5 right-5 z-10 flex flex-col gap-4">
      <button
        class="camera-info-btn"
        type="button"
        (click)="closeModal()"
        aria-label="Close"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <mask
            id="mask0_3851_8966"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="18"
            height="18"
          >
            <rect width="18" height="18" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_3851_8966)">
            <path
              d="M8.99961 10.0501L5.32461 13.7251C5.18711 13.8626 5.01211 13.9313 4.79961 13.9313C4.58711 13.9313 4.41211 13.8626 4.27461 13.7251C4.13711 13.5876 4.06836 13.4126 4.06836 13.2001C4.06836 12.9876 4.13711 12.8126 4.27461 12.6751L7.94961 9.0001L4.27461 5.3251C4.13711 5.1876 4.06836 5.0126 4.06836 4.8001C4.06836 4.5876 4.13711 4.4126 4.27461 4.2751C4.41211 4.1376 4.58711 4.06885 4.79961 4.06885C5.01211 4.06885 5.18711 4.1376 5.32461 4.2751L8.99961 7.9501L12.6746 4.2751C12.8121 4.1376 12.9871 4.06885 13.1996 4.06885C13.4121 4.06885 13.5871 4.1376 13.7246 4.2751C13.8621 4.4126 13.9309 4.5876 13.9309 4.8001C13.9309 5.0126 13.8621 5.1876 13.7246 5.3251L10.0496 9.0001L13.7246 12.6751C13.8621 12.8126 13.9309 12.9876 13.9309 13.2001C13.9309 13.4126 13.8621 13.5876 13.7246 13.7251C13.5871 13.8626 13.4121 13.9313 13.1996 13.9313C12.9871 13.9313 12.8121 13.8626 12.6746 13.7251L8.99961 10.0501Z"
              fill="white"
            />
          </g>
        </svg>
      </button>
      <button
        type="button"
        ngbPopover
        #questionPopover="ngbPopover"
        triggers="manual"
        [autoClose]="'outside'"
        [popoverClass]="
          isPreview ? 'preview-voe-popover' : 'question-info-popover'
        "
        [placement]="'left-top'"
        [ngbPopover]="questionPopoverContent"
        class="camera-info-btn"
        aria-label="Toggle question"
        (click)="toggleQuestionPopover()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
        >
          <path
            d="M12.5 2C18.02 2 22.5 6.48 22.5 12C22.5 17.52 18.02 22 12.5 22C6.98 22 2.5 17.52 2.5 12C2.5 6.48 6.98 2 12.5 2ZM12.5 4C8.09 4 4.5 7.59 4.5 12C4.5 16.41 8.09 20 12.5 20C16.91 20 20.5 16.41 20.5 12C20.5 7.59 16.91 4 12.5 4ZM13.5 18H11.5V16H13.5V18ZM8.67969 8.83008C9.22969 7.01008 11.0504 5.74004 13.1104 6.04004C14.8501 6.30017 16.2199 7.76999 16.46 9.50977C16.73 11.4198 15.4297 12.1603 14.4697 13.0703C14.3498 13.1802 14.2396 13.2903 14.1396 13.4102C14.1298 13.4202 14.1202 13.4403 14.1104 13.4502C14.0104 13.5702 13.9101 13.6999 13.8301 13.8398C13.8102 13.8697 13.8001 13.8998 13.7803 13.9297C13.6103 14.2297 13.5 14.58 13.5 15H11.5C11.5 14.5 11.5802 14.09 11.7002 13.75C11.7102 13.72 11.7097 13.6997 11.7197 13.6797C11.7297 13.6498 11.7498 13.6295 11.7598 13.5996C11.8298 13.4197 11.9198 13.2495 12.0098 13.0996C12.0197 13.0798 12.0301 13.0697 12.04 13.0498C12.0402 13.0401 12.0496 13.0399 12.0498 13.0303C12.8797 11.7804 14.3997 11.4901 14.5 10.1504C14.58 9.18039 13.8797 8.2498 12.9297 8.0498C11.8998 7.83001 10.9498 8.44018 10.6299 9.33008C10.4899 9.71003 10.16 10 9.75 10H9.5498C8.93996 9.99987 8.49984 9.40997 8.67969 8.83008Z"
            fill="white"
          />
        </svg>
      </button>
    </div>
    <div class="camera-preview">
      <video
        #cameraVideo
        autoplay
        playsinline
        muted
        class="camera-video"
      ></video>
    </div>
    <div class="camera-controls-row">
      <div class="camera-controls">
        <div class="record-timer" *ngIf="isRecording || recordingTime > 0">
          <span>{{ formatTime(recordingTime) }}</span>
        </div>
        <button
          class="record-btn"
          [class.recording]="isRecording"
          (click)="toggleRecording()"
          aria-label="Record"
          type="button"
        >
          <svg class="progress-ring" width="57" height="57">
            <circle
              class="ring-progress"
              cx="28.5"
              cy="28.5"
              r="24"
              stroke-width="4"
              fill="none"
              [attr.stroke-dasharray]="circumference"
              [attr.stroke-dashoffset]="dashOffset"
              [attr.stroke]="progressColor"
            />
          </svg>
          <div class="record-circle" *ngIf="!isRecording"></div>
          <div
            class="record-pause"
            [ngStyle]="{
              'background-color': recordingTime > MIN_TIME ? '#ff3b30' : '#fff'
            }"
            *ngIf="isRecording"
          ></div>
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #questionPopoverContent>
  <div class="bg-white p-4 rounded-lg w-60">
    <div>
      <label class="text-gray">{{
        'videoOpenEnded.question' | translate
      }}</label>
    </div>
    <div class="mt-2">
      <p class="text-sm text-gray-700">
        {{ question }}
      </p>
    </div>
  </div>
</ng-template>
